import { useQuery } from '@tanstack/react-query';
import type { CandidateEndpointResponse } from '../types/CandidateEndpoint';
import { fetchJson } from '@/utils/apiFetch';

export type ScopeType = 'suggest' | 'apply' | 'decline' | 'archived' | 'matched';

type Request = {
  id: number;
  scopes?: ScopeType | ScopeType[];
};

export default function useFetchCandidateEndpoint({ id, scopes }: Request) {
  return useQuery({
    queryKey: ['candidateEndpoint', id, scopes],
    queryFn: async () => {
      let url = `/agent/api/candidate_endpoints/${id}.json`;

      if (scopes) {
        const scopeParams = Array.isArray(scopes)
          ? scopes.map((s) => `scopes[]=${s}`).join('&')
          : `scope=${scopes}`;
        url = `/agent/api/candidate_endpoints/${id}?${scopeParams}`;
      }

      const data = await fetchJson<CandidateEndpointResponse>(url);

      return data;
    },
    refetchOnWindowFocus: false,
  });
}
